import { useAccount } from '@/hooks/query/account';

export const useIsBookedBetFeatureEnabled = () => {
	const { data: accountData } = useAccount(data => {
		const { Data } = data.data;

		return {
			EnableLicBooked: Data?.EnableLicBooked,
			EnableRewardSystem: Data?.RewardInfo.EnableRewardSystem,
		};
	});

	return Boolean(accountData?.EnableRewardSystem && accountData?.EnableLicBooked);
};